export type CategoryId = 'bovedilla' | 'caseton' | 'vigueta'

export interface CatalogItem {
  id: string
  name: string
  spec: string
  price: number
  tag?: string
}

export interface Category {
  id: CategoryId
  label: string
  shortLabel: string
  description: string
  unit: string
  items: CatalogItem[]
}

/** Cada bovedilla de 63 x 300 cm cubre aprox. 1.89 m² brutos */
export const BOVEDILLA_COVERAGE_M2 = 1.89

export const CATALOG: Category[] = [
  {
    id: 'bovedilla',
    label: 'Bovedilla EPS 63 x 300 cm',
    shortLabel: 'Bovedilla',
    description: 'Para vigueta y bovedilla. Pieza larga de 300 cm: menos cortes, más rendimiento.',
    unit: 'pza',
    items: [
      { id: 'bov-12', name: 'Bovedilla EPS', spec: '12 x 63 x 300 cm', price: 300, tag: 'Precio más bajo' },
      { id: 'bov-13', name: 'Bovedilla EPS', spec: '13 x 63 x 300 cm', price: 320 },
      { id: 'bov-15', name: 'Bovedilla EPS', spec: '15 x 63 x 300 cm', price: 365 },
      { id: 'bov-19', name: 'Bovedilla EPS', spec: '19 x 63 x 300 cm', price: 480 },
      { id: 'bov-24', name: 'Bovedilla EPS', spec: '24 x 63 x 300 cm', price: 540 },
    ],
  },
  {
    id: 'caseton',
    label: 'Casetón EPS',
    shortLabel: 'Casetón',
    description: 'Para losa reticular o aligerada. Medidas 40 x 40, 60 x 40 y 60 x 60 cm.',
    unit: 'pza',
    items: [
      { id: 'cas-40-40-10', name: 'Casetón EPS', spec: '40 x 40 x 10 cm', price: 20, tag: 'Precio más bajo' },
      { id: 'cas-40-40-15', name: 'Casetón EPS', spec: '40 x 40 x 15 cm', price: 30 },
      { id: 'cas-40-40-20', name: 'Casetón EPS', spec: '40 x 40 x 20 cm', price: 40 },
      { id: 'cas-40-40-25', name: 'Casetón EPS', spec: '40 x 40 x 25 cm', price: 50 },
      { id: 'cas-60-40-15', name: 'Casetón EPS', spec: '60 x 40 x 15 cm', price: 62 },
      { id: 'cas-60-40-20', name: 'Casetón EPS', spec: '60 x 40 x 20 cm', price: 70 },
      { id: 'cas-60-60-10', name: 'Casetón EPS', spec: '60 x 60 x 10 cm', price: 78 },
      { id: 'cas-60-60-15', name: 'Casetón EPS', spec: '60 x 60 x 15 cm', price: 86 },
      { id: 'cas-60-60-20', name: 'Casetón EPS', spec: '60 x 60 x 20 cm', price: 94 },
      { id: 'cas-60-60-25', name: 'Casetón EPS', spec: '60 x 60 x 25 cm', price: 151 },
    ],
  },
  {
    id: 'vigueta',
    label: 'Vigueta',
    shortLabel: 'Vigueta',
    description: 'Semi-vigueta y vigueta pretensada para completar tu sistema de losa. Confirma largo al cotizar.',
    unit: 'pza',
    items: [
      { id: 'vig-ss-13', name: 'Semi-vigueta sencilla', spec: 'Medida 1/3', price: 110 },
      { id: 'vig-ss-345', name: 'Semi-vigueta sencilla', spec: 'Medida 3/4.5', price: 120 },
      { id: 'vig-sd-13', name: 'Semi-vigueta doble armadura', spec: 'Medida 1/3', price: 125 },
      { id: 'vig-sd-345', name: 'Semi-vigueta doble armadura', spec: 'Medida 3/4.5', price: 135 },
      { id: 'vig-pt-13', name: 'Vigueta pretensada', spec: 'Medida 1/3', price: 180 },
      { id: 'vig-pt-35', name: 'Vigueta pretensada', spec: 'Medida 3/5', price: 195 },
    ],
  },
]

export function findItem(itemId: string): { item: CatalogItem; category: Category } | null {
  for (const category of CATALOG) {
    const item = category.items.find((i) => i.id === itemId)
    if (item) return { item, category }
  }
  return null
}

export function lowestPrice(category: Category): number {
  return Math.min(...category.items.map((i) => i.price))
}
